export const byName = (name) => (e) => e.name === name;
